<template>
    <b-card class="sa-card sa-card-border" header="Consegne" header-tag="header" footer-tag="footer" title="">
        <b-col v-if="idPresidio !== null" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <b-card v-for="paziente in pazienti" class="sa-card sa-card-border" :header="paziente.lastname + ' ' + paziente.firstname" header-tag="header" footer-tag="footer" title="" :key="paziente.idAccettazione">
                <template #header>
                    <div class="d-flex align-items-center justify-content-between">
                        <span class="flex-grow-1" style="cursor: pointer" v-b-toggle="paziente.idAccettazione"> {{ paziente.lastname }} {{ paziente.firstname }} </span>
                        <b-icon icon="chevron-down" class="mx-2" style="cursor: pointer" v-b-toggle="paziente.idAccettazione"></b-icon>
                        <b-button size="sm" variant="outline-danger" @click.stop="onClickCancellaListaConsegna(paziente)">
                            <font-awesome-icon icon="trash" />
                        </b-button>
                    </div>
                </template>
                <b-collapse :id="paziente.idAccettazione" role="tabpanel">
                    <div v-for="(voceDiario, index) in paziente.vociDiari" :key="index" class="row">
                        <div class="col">
                            <b-row>
                                <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                                    <span>
                                        <h4 :class="getTipologia(voceDiario.tipologia)">
                                            <strong>{{ voceDiario.tipologia }} - {{ voceDiario.denominazioneDiario }}</strong>

                                            <!--    <b-button size="sm" variant="outline-danger outline-danger-noborder sa-margin-right float-right" @click="onClickCancellaConsegna(voceDiario)"><b-icon icon="trash"></b-icon></b-button> -->
                                        </h4>

                                        <span>
                                            <h5>
                                                <strong>{{ voceDiario.nomeAttivita }}</strong>
                                            </h5>
                                        </span>
                                    </span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <label class="sa-label-data">Data Programmazione: </label>
                                    <span>{{ formatDateTime(voceDiario.dataOraProgrammata) }}</span>
                                </b-col>
                                <b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                                    <b-button size="sm" variant="outline-danger  float-right" @click="onClickCancellaConsegna(voceDiario)">
                                        <font-awesome-icon icon="trash"></font-awesome-icon>
                                    </b-button>
                                </b-col>
                                <!--      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <span>
                                        <h5>
                                            <strong>{{ voceDiario.nomeAttivita }}</strong>
                                        </h5>
                                    </span>
                                </b-col> -->
                                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <span v-html="voceDiario.annotazione"></span>
                                </b-col>
                                <!--     <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">Data Programmazione: </label>
                                    <span>{{ formatDateTime(voceDiario.dataOraProgrammata) }}</span>
                                </b-col> -->
                            </b-row>
                        </div>
                    </div>
                </b-collapse>
            </b-card>
        </b-col>
        <b-col v-else cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <div style="width: 100%; display: flex; justify-content: center">
                <b-alert :show="true" variant="warning" style="width: 50%"> Selezionare un Presidio</b-alert>
            </div>
        </b-col>
        <modal-error ref="cmpModalError"></modal-error>
    </b-card>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    computed: {},
    data() {
        return {
            page: 1,
            perPage: 6,
            totalRow: 0,
            filterIdentificativo: "",
            key: 0,
            pathResource: "/rsadiarivoci/consegne",
            pathResourceDiariVoceOperatori: "/rsadiarivocioperatori",
            items: [],
            pazienti: [],
            jsonData: {},
            idPresidio: null,
            filtro: { idPresidio: null },
            presidio: {},
        };
    },
    mounted() {
        let me = this;
        me.filtro = {};
        /*      if (localStorage.getItem("presidio")) {
            me.presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
            me.idPresidio = me.presidio ? me.presidio.idPresidio : null;
            me.filtro.idPresidio = me.idPresidio;
        } */
    },
    watch: {},
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let filtro = {};
            // me.idPresidio = null;
            if (localStorage.getItem("presidio")) {
                me.presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
                me.idPresidio = me.presidio ? me.presidio.idPresidio : null;
                filtro.idPresidio = me.idPresidio;
            }
            if (filtro.idPresidio) {
                me.loadDataResources(me.pathResource, filtro, me.resultResponseLoadData, me.resultErrorLoadData);
            } else {
                me.$emit("afterLoadData");
            }
        },
        resultResponseLoadData(response) {
            let me = this;
            me.items = [];
            me.pazienti = [];
            me.items = response.data.data.list;
            me.items.forEach((element) => {
                if (!me.pazienti[element.idAccettazione]) {
                    me.pazienti[element.idAccettazione] = {
                        firstname: element.nomePaziente,
                        lastname: element.cognomePaziente,
                        idAccettazione: element.idAccettazione,
                        vociDiari: [],
                    };
                }
                me.pazienti[element.idAccettazione].vociDiari.push(element);
            });
            me.pazienti = Object.values(me.pazienti);
            me.$emit("afterLoadData");
        },
        resultErrorLoadData(error) {
            this.$emit("afterLoadData");
            let messaggio = error.response ? error.response.data.messaggio : "ERRORE NON GESTITO";
            this.$refs.cmpModalError.show(messaggio);
        },
        getTipologia(tipologia) {
            let returnValue = "";
            returnValue = tipologia === "NON ESEGUITA" ? "non-eseguita" : tipologia;
            return returnValue.toLowerCase();
        },
        onClickCancellaConsegna(data) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo elemento?", {
                    title: "Eliminazione Soggetto",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.cancellaConsegna(data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        cancellaConsegna(data) {
            let me = this;
            me.jsonData = { note: "", idRsaDiariVoci: data.id };
            UtilityMixin.methods.saveResource(me.pathResourceDiariVoceOperatori, me.jsonData, me.resultResponseSaveConsegna, me.resultErrorSaveConsegna);
        },
        resultResponseSaveConsegna() {
            let me = this;
            me.loadData();
        },
        resultErrorSaveConsegna(error) {
            this.$refs.cmpModalError.show(error.response.data.messaggio);
        },

        onClickCancellaListaConsegna(data) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questi elementi?", {
                    title: "Eliminazione Soggetto",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.clickCancellaListaConsegna(data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        clickCancellaListaConsegna(data) {
            let me = this;
            let array = [];
            data.vociDiari.forEach((element) => {
                let jsonData = { note: "", idRsaDiariVoci: element.id };
                array.push(jsonData);
            });
            me.saveResource(me.pathResourceDiariVoceOperatori + "/lista", array, me.resulResponseCancellaListaConsegna, null);
        },
        resulResponseCancellaListaConsegna() {
            this.loadData();
        },
    },
};
</script>
<style>
.programmata {
    color: #00a3ff !important;
}
.nota {
    color: #00838f !important;
}
.conclusa {
    color: #f54545 !important;
}
.eseguita {
    color: #008000 !important;
}
.non-eseguita {
    color: #f54545 !important;
}
</style>
